import { styled } from '@mui/material/styles';
import { Dialog, DialogContent } from '@mui/material';

import { useAppSelector } from '../../hooks/useAppSelector';
import * as providerSlice from '../../data/provider.slice';
import { useTranslation } from 'react-i18next';
import BasicDialogHeader from './BasicDialogHeader';
import ProviderDocuments from '../home/providers/ProviderDocuments';

const PREFIX = 'OnboardDocumentsDialog';

const classes = {
  content: `${PREFIX}-content`,
};

const RootDialog = styled(Dialog)(({ theme }) => ({
  [`& .${classes.content}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },
}));
interface OnboardDocumentsDialogProps {
  open: boolean;
  close: () => void;
  uploadingDocument: boolean;
}

export default function OnboardDocumentsDialog({
  open,
  close,
  uploadingDocument,
}: OnboardDocumentsDialogProps) {
  const { t } = useTranslation('common');
  const provider = useAppSelector(providerSlice.selectProvider);

  const handleClose = () => {
    close();
  };

  return (
    <RootDialog fullScreen open={open} onClose={handleClose}>
      <BasicDialogHeader title={t('onboard.documents')} close={close} />
      <DialogContent className={classes.content}>
        <ProviderDocuments
          provider={provider}
          uploadingDocument={uploadingDocument}
          readOnly={false}
          allowView={true}
        />
      </DialogContent>
    </RootDialog>
  );
}
